import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  InputGroup,
} from "reactstrap"
import Select from "react-select"
import makeAnimated from "react-select/animated"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/BreadcrumbBack"

//i18n
import { withTranslation } from "react-i18next"

//redux
import {
  getCities as onCities,
  getDistricts as onDistricts,
  districtReset as onDistrictReset,
  addBranch as onSave,
  companiesResetError as onClearError,
} from "store/actions"
import { useDispatch, useSelector } from "react-redux"

//Custom CSS
import "./custom.scss"
import moment from "moment"
import Swal from "sweetalert2"
import { Link } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"

import InputMask from "react-input-mask"
import { isEmpty } from "lodash"
import Loading from "components/Common/Loading"

const BranchCreate = props => {
  //meta title
  document.title = props.t("Create Branch")

  const query = new URLSearchParams(props.location.search)

  const dispatch = useDispatch()
  const { error, cities, districts, loading } = useSelector(state => ({
    error: state.Companies?.error,
    cities: state.Companies?.cities || [],
    districts: state.Companies?.districts || [],
    loading: state.Companies?.loading || false
  }))


  const [data, setData] = useState(null)

  const breadcrumbItems = [
    { title: props.t("Companies"), link: "/v1/companies" },
    { title: props.t("Create Branch"), link: "#" },
  ]

  const {
    match: { params },
  } = props

  useEffect(() => {
    if (isEmpty(cities)) {
      dispatch(onCities())
    }
  }, [])

  /*
  Anonim Şirket.
Limited Şirket.
Kollektif Şirket.
Komandit Şirket.
Kooperatif Şirket
  */
  const branchTypes = [
    { label: "Anonim Şirket", value: "anonim-sirket" },
    { label: "Limited Şirket", value: "limited-sirket" },
    { label: "Kollektif Şirket", value: "kollektif-sirket" },
    { label: "Komandit Şirket", value: "komandit-sirket" },
    { label: "Kooperatif Şirket", value: "kooperatif-sirket" },
  ]

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      branchType: "",
      address: "",
      zipCode: "",
      city: "",
      state: "",
      phone: "",
      email: "",
      taxOffice: "",
      taxId: "", 
      description: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(props.t("Required")),
      taxId: Yup.string().required(props.t("Required")),
      taxOffice: Yup.string().required(props.t("Required")),
      city: Yup.string().required(props.t("Required")),
      state: Yup.string().required(props.t("Required")),
      // className: Yup.string().required(props.t("Required")),
      // category: Yup.string().required(props.t("Required")),
      // subCategory: Yup.string().required(props.t("Required")),
    }),
    onSubmit: values => {
      console.log("values", values)
      //props.history.push(`/v1/products/create/step2/01`)
      dispatch(onSave(params.id, values, props.history))
    },
  })

  const insert = (arr, index, ...newItems) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted items
    ...newItems,
    // part of the array after the specified index
    ...arr.slice(index),
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Branch")}
            backLink={!isEmpty(query.get('cid')) || params.id?`/v1/companies/branches/${query.get('cid') || params.id}`:"/v1/companies"}
            breadcrumbItems={breadcrumbItems}
          />
          <Loading status={loading} />
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">{props.t("New Branch")}</h4>
                  <p className="card-title-desc">
                    {props.t("New Branch Description")}
                  </p>
                  <Form
                    className="needs-validation"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom01">
                            {props.t("Branch Name")}
                          </Label>
                          <Input
                            name="name"
                            placeholder={props.t("Branch Name")}
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col> 
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationAddress">
                            {props.t("Address")}
                          </Label>
                          <Input
                            name="address"
                            placeholder={props.t("Address")}
                            type="textarea"
                            className="form-control"
                            id="validationAddress"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.address || ""}
                            invalid={
                              validation.touched.address &&
                              validation.errors.address
                                ? true
                                : false
                            }
                          />
                          {validation.touched.address &&
                          validation.errors.address ? (
                            <FormFeedback type="invalid">
                              {validation.errors.address}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationZipCode">
                            {props.t("ZipCode")}
                          </Label>
                          <Input
                            name="zipCode"
                            placeholder={props.t("ZipCode")}
                            type="text"
                            className="form-control"
                            id="validationZipCode"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.zipCode || ""}
                            invalid={
                              validation.touched.zipCode &&
                              validation.errors.zipCode
                                ? true
                                : false
                            }
                          />
                          {validation.touched.zipCode &&
                          validation.errors.zipCode ? (
                            <FormFeedback type="invalid">
                              {validation.errors.zipCode}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                       <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCity">
                            {props.t("City")}
                          </Label>
                          <select
                            id={`city`}
                            className={
                              validation.touched.city &&
                              validation.errors.city
                                ? "form-select is-invalid"
                                : "form-select"
                            }
                            name={`city`}
                            onChange={e => {
                              validation.handleChange(e)
                              let _cities = [...cities]
                              let city = _cities.find(
                                x => x.name == e.target.value
                              )
                              if (city) {
                                console.log(city)
                                dispatch(onDistricts(city.id))
                              } else {
                                dispatch(onDistrictReset())
                                validation.setFieldValue("state", "")
                              }
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.city || ""}
                          >
                            <option value="">{props.t("Select")}</option>
                            {cities.map((item, idx) => (
                              <option key={idx} value={item.name}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {validation.touched.city &&
                          validation.errors.city ? (
                            <FormFeedback type="invalid">
                              {validation.errors.city}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationState">
                            {props.t("State")}
                          </Label>
                          <select
                            id={`state`}
                            className={
                              validation.touched.state &&
                              validation.errors.state
                                ? "form-select is-invalid"
                                : "form-select"
                            }
                            name={`state`}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.state || ""}
                          >
                            <option value="">{props.t("Select")}</option>
                            {districts.map((item, idx) => (
                              <option key={idx} value={item.name}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {validation.touched.state &&
                          validation.errors.state ? (
                            <FormFeedback type="invalid">
                              {validation.errors.state}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationBranchPhone">
                            {props.t("Branch Phone")}
                          </Label>
                          <Input
                            tag={InputMask}
                            mask={"0(999) 999-9999"}
                            name="phone"
                            placeholder={props.t("Branch Phone")}
                            type="text"
                            className="form-control"
                            id="validationBranchPhone"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.phone || ""}
                            invalid={
                              validation.touched.phone &&
                              validation.errors.phone
                                ? true
                                : false
                            }
                          />
                          {validation.touched.phone &&
                          validation.errors.phone ? (
                            <FormFeedback type="invalid">
                              {validation.errors.phone}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="8">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationEmail">
                            {props.t("Branch Email")}
                          </Label>
                          <Input
                            name="email"
                            placeholder={props.t("Branch Email")}
                            type="text"
                            className="form-control"
                            id="validationEmail"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationTaxOffice">
                            {props.t("TaxOffice")}
                          </Label>
                          <Input
                            name="taxOffice"
                            placeholder={props.t("TaxOffice")}
                            type="text"
                            className="form-control"
                            id="validationTaxOffice"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.taxOffice || ""}
                            invalid={
                              validation.touched.taxOffice &&
                              validation.errors.taxOffice
                                ? true
                                : false
                            }
                          />
                          {validation.touched.taxOffice &&
                          validation.errors.taxOffice ? (
                            <FormFeedback type="invalid">
                              {validation.errors.taxOffice}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationTaxId">
                            {props.t("TaxId")}
                          </Label>
                          <Input
                            name="taxId"
                            placeholder={props.t("TaxId")}
                            type="text"
                            className="form-control"
                            id="validationTaxId"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.taxId || ""}
                            invalid={
                              validation.touched.taxId &&
                              validation.errors.taxId
                                ? true
                                : false
                            }
                          />
                          {validation.touched.taxId &&
                          validation.errors.taxId ? (
                            <FormFeedback type="invalid">
                              {validation.errors.taxId}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col> 
                    </Row>

                    <Row>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationDescription">
                            {props.t("Description")}
                          </Label>
                          <Input
                            name="description"
                            placeholder={props.t("Description")}
                            type="textarea"
                            className="form-control"
                            id="validationDescription"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description || ""}
                            invalid={
                              validation.touched.description &&
                              validation.errors.description
                                ? true
                                : false
                            }
                          />
                          {validation.touched.description &&
                          validation.errors.description ? (
                            <FormFeedback type="invalid">
                              {validation.errors.description}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button color="primary" type="submit">
                      {props.t("Save")}
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

BranchCreate.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
}

export default withTranslation()(BranchCreate)
